/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import {AttributeService} from "./AttributeService";

class AttributeServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AttributeService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AttributeServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/AttributeServiceProvider.js